import { render, staticRenderFns } from "./TradingChart.vue?vue&type=template&id=34867d1c&"
import script from "./TradingChart.vue?vue&type=script&lang=js&"
export * from "./TradingChart.vue?vue&type=script&lang=js&"
import style0 from "./TradingChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports